<template>
<span class="vcode">
	<!-- <Button @click="getCode" v-if="t==time||t==60">{{text}}</Button>
	<Button class="right" v-else :disabled="true">{{t}}秒</Button> -->
	<Button type="info" @click="showSlider('TEXT')" v-show="t==60">获取验证码</Button>
	<div v-show="t<60" style="font-size:12px">
		<p style="line-height:normal">{{text}}&nbsp;&nbsp;&nbsp;没收到短信？</p>
		<p style="line-height:normal"><a @click="showSlider('VOICE')">点此获取语音验证码</a></p>
	</div>
</span>
</template>
<script>
export default {
	data () {
		return {
			t:this.time || 60,
		}
	},
	props:{
		phone:[String,Number],
		type:[String,Number],
		time:[String,Number],
		agree:[Boolean],
		isLogin:{
			type:Boolean,
			default:false
		}
	
	},
	computed:{
		text () {
			// return this.t==60?'获取验证码':this.t+'s'
			return this.t+'s'
		}
	},
	methods: {
		showSlider(type) {
			if (this.phone == '' || !this.rules.tel.test(this.phone)) {
				this.toast('手机号码格式不正确', 'error');
				return
			}
			this.$emit('showSlider',type)
		},
		showTime() {
			let that = this;
			//点击获取验证码后再点击获取语音验证码，计时不清空
			if (that.t < 60) return
			let c = setInterval(() => {
				if (that.t > 0) {
					that.t--
				} else {
					that.t = that.time || 60;
					this.$emit('changeShow')
					clearInterval(c);
				}
			}, 1000)
		},
		send(codeType) {
			if(this.phone==''||!this.rules.tel.test(this.phone)){
				this.toast('手机号码格式不正确','error');
				return
			}
			if(this.isLogin){
				if(!this.agree){
					this.toast('请先阅读协议','error');
					return
				}
			}
			let url = codeType=='TEXT'?'/user/sendPhoneCode.origin':'/user/sendPhoneVoiceCode.origin'
			this.$axios.post(url,{
				phone:this.phone,
				type:this.type
			}).then(res=> {
				console.log(res)
				this.toast('发送成功')
				let that = this;
				//点击获取验证码后再点击获取语音验证码，计时不清空
				if(that.t<60)return
				let c = setInterval(()=>{
					if(that.t>0){
						that.t--
					}else{
						that.t = that.time || 60;
						clearInterval(c);
					}
				},1000)
			})
        },
	}
}
</script>
<style scoped>
	.vcode{
		width:100%;
		display:inline-block;
	}
</style>


// WEBPACK FOOTER //
// src/components/common/VCode.vue